<template>
  <div>
    <v-text-field
      v-validate="validator"
      outlined
      :value="value"
      label="Número"
      :class="[(errors.first(field) || error) && 'block']"
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object
  },
  data: () => ({
    error: null
  })
}
</script>

<style></style>
